// extracted by mini-css-extract-plugin
module.exports = {"cbWrapper":"Checkbox_cbWrapper__1WT0A","checkbox":"Checkbox_checkbox__2DiPf","selected":"Checkbox_selected__2V8Xp","label":"Checkbox_label__2R9H7"};